export default {
  store_layout: {
    headline: 'Here you can edit the layout for header and footer of your stores',
    filter: {
      fields: {
        search: {
          placeholder: 'Filter by name'
        }
      }
    },
    dialogs: {
      close: {
        title: 'Close Store Layout Form',
        content: 'Do you want to close this page without saving?'
      }
    },
    other: {
      placeholder_block_text: 'Store Page Content'
    },
    form: {
      title: {
        create: 'Create Store Layout',
        edit: 'Edit Store Layout'
      },
      fields: {
        name: {
          title: 'Name',
          placeholder: 'Type a name'
        },
        layout_i18ns: {
          tabs: {
            en: {
              title: 'English'
            },
            ar: {
              title: 'Arabic'
            },
            fr: {
              title: 'French'
            },
            es: {
              title: 'Spanish'
            },
            it: {
              title: 'Italian'
            }
          }
        }
      },
      buttons: {
        create: 'Create layout',
        duplicate: 'Duplicate',
        save: 'save layout',
        preview: 'preview',
        edit: 'edit',
        cancel: 'cancel',
        delete: 'delete'
      }
    }
  },
  store_page: {
    store_page_i18n: {
      dialogs: {
        delete: {
          title: 'Delete Store Page',
          content: 'Are you sure you want to delete this Store Page?'
        },
        close: {
          title: 'Close Store Page Form',
          content: 'Do you want to close this page without saving?'
        }
      },
      buttons: {
        preview: 'Preview',
        edit: 'Edit',
        delete: 'Delete'
      },
      form: {
        fields: {
          content: {
            tab_name: 'Content'
          },
          page_i18ns: {
            tabs: {
              en: {
                title: 'English'
              },
              ar: {
                title: 'Arabic'
              },
              fr: {
                title: 'French'
              },
              es: {
                title: 'Spanish'
              },
              it: {
                title: 'Italian'
              }
            }
          },
          meta_data: {
            tab_name: 'Title & Description',
            title: {
              title: 'Title',
              placeholder: 'Type the page meta title'
            },
            description: {
              title: 'Description',
              placeholder: 'Type the page meta description'
            }
          },
          tracking_data: {
            tab_name: 'Pixels'
          }
        }
      }
    }
  },
  store_settings: {
    dialogs: {
      update_status: {
        title: 'Store Status Update',
        content: 'Are you sure you want to update the status of this store ?'
      }
    },
    form: {
      edit: 'Edit Store',
      create: 'Create Store',
      buttons: {
        create: 'Create store',
        save: 'save store',
        cancel: 'cancel'
      },
      fields: {
        create: {
          alert: {
            info: {
              title: 'Note:',
              content: 'You can attach your domain name to your store later.'
            }
          },
          store_name: {
            title: 'Store Name',
            placeholder: 'Enter store name',
            hint: 'the store name must contain only english letters, numbers and -.'
          },
          language: {
            title: 'Language'
          }
        },
        edit: {
          tabs: {
            general: {
              title: 'General',
              fields: {
                language_type: {
                  title: 'Language',
                  plan_warning: '<span style="font-weight: bold">Plan upgrade</span> is required to enable this option!'
                },
                default_language: {
                  title: 'Default Language',
                  options: {
                    english: 'English',
                    arabic: 'Arabic',
                    french: 'French',
                    spanish: 'Spanish',
                    italian: 'Italian'
                  }
                }
              }
            },
            domain: {
              title: 'Domain',
              fields: {
                substitution_domain: {
                  title: 'Fallback Domain'
                },
                domain: {
                  title: 'Main Domain',
                  placeholder: 'Select Domain'
                }
              }
            },
            style: {
              title: 'Style',
              fields: {
                layout: {
                  title: 'Store Layout for Header & Footer'
                }
              }
            },
            checkout_form: {
              title: 'Checkout Form',
              fields: {
                general: {
                  title: 'General'
                },
                checkout_form: {
                  title: 'Checkout Form'
                },
                shipping: {
                  title: 'Shipping'
                },
                reviews: {
                  title: 'Reviews'
                }
              }
            },
            addons: {
              title: 'Addons'
            },
            pixels: {
              title: 'Pixels'
            },
            payment: {
              title: 'Online Payment'
            }
          }
        }
      }
    },
    filter: {
      search: {
        placeholder: 'filter by domain/subdomain'
      },
      search_by_user: {
        placeholder: 'filter by user'
      },
      domain: {
        placeholder: 'Select a domain'
      }
    }
  }
};